export default __webpack_public_path__ + "static/media/ph.31b58dbb.svg";